import { createSlice } from "@reduxjs/toolkit";
import {
  getTemplates, saveTemplate, deleteTemplate,
  getAssignments, upsertAssignment, logKpi,
  getPerformance, getTeamPerformance, getAttendance, markAttendance,
} from "./ThunkActions";
import { IEmployeeKpiState, REDUCER_NAME } from "./Types";

const initialState: IEmployeeKpiState = {
  templates: [], totalWeight: 0, assignments: [],
  performance: null, teamPerformance: [], attendance: [],
  attendanceSummary: [], isLoading: false, errorMessage: null,
};

const employeeKpiSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: { reset: () => initialState },
  extraReducers: (builder) => {
    builder
      .addCase(getTemplates.pending, (state) => { state.isLoading = true; })
      .addCase(getTemplates.fulfilled, (state, action) => {
        const d = (action.payload as any)?.data?.data;
        state.templates = d?.templates || [];
        state.totalWeight = d?.totalWeight || 0;
        state.isLoading = false;
      })
      .addCase(getTemplates.rejected, (state) => { state.isLoading = false; })

      .addCase(saveTemplate.fulfilled, () => {})
      .addCase(deleteTemplate.fulfilled, () => {})

      .addCase(getAssignments.pending, (state) => { state.isLoading = true; })
      .addCase(getAssignments.fulfilled, (state, action) => {
        const d = (action.payload as any)?.data?.data;
        state.assignments = d?.assignments || [];
        state.isLoading = false;
      })
      .addCase(getAssignments.rejected, (state) => { state.isLoading = false; })

      .addCase(upsertAssignment.fulfilled, () => {})
      .addCase(logKpi.fulfilled, () => {})

      .addCase(getPerformance.pending, (state) => { state.isLoading = true; })
      .addCase(getPerformance.fulfilled, (state, action) => {
        state.performance = (action.payload as any)?.data?.data || null;
        state.isLoading = false;
      })
      .addCase(getPerformance.rejected, (state) => { state.isLoading = false; })

      .addCase(getTeamPerformance.pending, (state) => { state.isLoading = true; })
      .addCase(getTeamPerformance.fulfilled, (state, action) => {
        const d = (action.payload as any)?.data?.data;
        state.teamPerformance = d?.employees || [];
        state.isLoading = false;
      })
      .addCase(getTeamPerformance.rejected, (state) => { state.isLoading = false; })

      .addCase(getAttendance.pending, (state) => { state.isLoading = true; })
      .addCase(getAttendance.fulfilled, (state, action) => {
        const d = (action.payload as any)?.data?.data;
        state.attendance = d?.attendance || [];
        state.attendanceSummary = d?.summary || [];
        state.isLoading = false;
      })
      .addCase(getAttendance.rejected, (state) => { state.isLoading = false; })
      .addCase(markAttendance.fulfilled, () => {});
  },
});

export const { reset } = employeeKpiSlice.actions;
export default employeeKpiSlice.reducer;
